import { gql } from '@apollo/client';

export const UPDATE_DAILY_MEETING_ATTRIBUTION = gql`
    mutation UpdateDailyMeetingAttribution($input: UpdateDailyMeetingAttributionInput!) {
        updateDailyMeetingAttribution(input: $input) {
            id
            warehouseId
            statDate
            reason
            notes
            expectedRecoveryDate
            claimStatus
            claimerId
            claimerName
            creatorId
            creatorName
            updatedById
            updatedByName
            createdAt
            updatedAt
        }
    }
`;
